// extracted by mini-css-extract-plugin
export default {"link":"link--O6ff","trucks":"trucks--bUXG","disabled":"disabled--ULTJ"};